import React from 'react';

import styled from '@emotion/styled';
import { Tooltip, tooltipClasses } from '@mui/material';

import { theme } from '@/theme';

import type { BlackTooltipProps } from './BlackTooltip';

export const BlackStyledTooltip = styled(({ className, ...props }: BlackTooltipProps) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
))(() => ({
    [`& .${tooltipClasses.arrow}`]: {
        color: theme.palette.components.listingTooltip,
    },
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.components.listingTooltip,
    },
}));
